import React from 'react'
// import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { List, ListItemButton, ListItemText, ListSubheader, Box, Button } from '@mui/material';

function SecondChild({ children, parentName, setFChild, setSChild ,handleToggle, checked}) {
    return (

        <List>
            <ListSubheader sx={{ backgroundColor: 'rgb(245, 242, 242)' }}>
                {parentName}
            </ListSubheader>
            <Box display='flex' justifyContent='space-between' mt={1}>
                <Button onClick={()=> {setSChild(false); setFChild(true)}} style={{ textTransform: 'none' }} ><ArrowBackIosNewOutlinedIcon sx={{fontSize: '14px'}}/>&nbsp;Back</Button>
                <Button onClick={()=>{setFChild(false); setSChild(false)}}  style={{ textTransform: 'none' }} ><MenuOutlinedIcon sx={{fontSize: '14px'}}/>&nbsp;All Categories</Button>
            </Box>
            {children.map(item => (
                <ListItemButton key={item.id} onClick={()=> handleToggle(item.id, item)} sx={{backgroundColor: checked.includes(item.id)? '#daebe8': 'transparent'}}>
                    <ListItemText primary={item.label} />
                </ListItemButton>
            ))}
        </List>
    )
}

export default SecondChild